import { featureToggles, isApp } from '@otto-ec/eprivacy-shared'
import { LOAD_CB_LAZY_TOGGLE } from './core'

void (async () => {
  if (!isApp() || !featureToggles('cb_no_load_in_app_context', false)) {
    const isLoadCbLazyEnabled = featureToggles(LOAD_CB_LAZY_TOGGLE, false)
    if (isLoadCbLazyEnabled) {
      await import('./bootstrap-lazy').then(({ bootstrapLazy }) =>
        bootstrapLazy()
      )
    } else {
      await import('./bootstrap').then(({ bootstrap }) => bootstrap())
    }
  }
})()
